import * as actionTypes from './actionTypes';

export const initKryTakeCards = () => {
    return {
        type: actionTypes.INIT_TAKE_CARDS
    };
};

export const getTakeCards = () => {
    return {
        type: actionTypes.GET_TAKE_CARDS
    };
};

export const setTakeCards = (cards) => {
    return {
        type: actionTypes.SET_TAKE_CARDS,
        cards: cards
    };
};

export const getTakeCardsFailed = (error, easymessage, status, message) => {
    return {
        type: actionTypes.GET_TAKE_CARDS_FAILED,
        error: error,
        easymessage: easymessage,
        status: status,
        message: message
    };
};

export const setTaakStatus = (id, status) => {
    return {
        type: actionTypes.SET_TAAK_STATUS,
        id: id,
        status: status
    };
};


export const setTaakStatusFailed = (error, easymessage, status, message) => {
    return {
        type: actionTypes.SET_TAAK_STATUS_FAILED,
        error: error,
        easymessage: easymessage,
        status: status,
        message: message
    };
};

export const setClearTaakStatusFailed = () => {
    return {
        type: actionTypes.CLEAR_TAAK_STATUS_FAILED,
    };
};

export const setTakeFilter = (tipe, ids) => {
    return {
        type: actionTypes.SET_TAKE_FILTER,
        tipe: tipe,
        ids: ids
    };
};

export const clearTakeFilter = () => {
    return {
        type: actionTypes.CLEAR_TAKE_FILTER,
    };
};

export const setTaakIndex = (status, ouindexes, indexes, lane, itemcount) => {
    return {
        type: actionTypes.SET_TAAK_INDEX,
        status: status,
        ouindexes: ouindexes,
        indexes: indexes,
        lane: lane,
        itemcount: itemcount
    };
};


export const setTaakIndexFailed = (error, easymessage, status, message) => {
    return {
        type: actionTypes.SET_TAAK_INDEX_FAILED,
        error: error,
        easymessage: easymessage,
        status: status,
        message: message
    };
};

export const setClearTaakIndexFailed = () => {
    return {
        type: actionTypes.CLEAR_TAAK_INDEX_FAILED,
    };
};

export const openSkepInstruksie = (data, open) => {
    return {
        type: actionTypes.OPEN_SKEP_INSTRUKSIE,
        data: data,
        open: open
    };
};

export const initKryTakeCardsPerLane = (lane, lastindex, lazy, limit, lastid) => {
    return {
        type: actionTypes.INIT_TAKE_CARDS_PER_LANE,
        lane: lane,
        lastindex: lastindex,
        lazy: lazy,
        limit: limit,
        lastid: lastid
    };
};

export const getTakeCardsPerLane = (lane, lastindex, limit, lastid) => {
    return {
        type: actionTypes.GET_TAKE_CARDS_PER_LANE,
        lane: lane,
        lastindex: lastindex,
        limit: limit,
        lastid: lastid
    };
};

export const setTakeCardsPerLaneLoading = (lane) => {
    return {
        type: actionTypes.SET_TAKE_CARDS_PER_LANE_LOADING,
        lane: lane
    };
};

export const setTakeCardsPerLane = (cards, lane) => {
    return {
        type: actionTypes.SET_TAKE_CARDS_PER_LANE,
        cards: cards,
        lane: lane
    };
};

export const getTakeCardsPerLaneFailed = (error, easymessage, status, message, lane) => {
    return {
        type: actionTypes.GET_TAKE_CARDS_PER_LANE_FAILED,
        error: error,
        easymessage: easymessage,
        status: status,
        message: message,
        lane: lane
    };
};

export const setTakeCardsPerLaneLazyLoading = (lane) => {
    return {
        type: actionTypes.SET_TAKE_CARDS_PER_LANE_LAZY_LOADING,
        lane: lane
    };
};

export const setTakeCardsPerLaneLazy = (cards, lane) => {
    return {
        type: actionTypes.SET_TAKE_CARDS_PER_LANE_LAZY,
        cards: cards,
        lane: lane
    };
};

export const setTakeCardsSkuif = (value) => {
    return {
        type: actionTypes.SET_TAKE_CARDS_SKUIF,
        value: value
    };
};